<template>
  <div id="app">
    <!-- loader -->
    <Loader v-if="isLoading"></Loader>

    <div class="container-fluid">
      <!-- openMap&closeMap -->
      <div @click="openMap=!openMap" class="openMap">
        <i v-if="openMap" class="fa fa-map-marker-alt">CloseMap</i>
        <i v-else class="fa fa-map-marker-alt">OpenMap</i>
      </div>

      <div class="row">
        <!-- searchForm -->
        <div class="col-12 col-lg-7">
          <!-- formGroup -->
          <div class="row formGroup mt-3">
            <h5 class="col-12 formTitle">
              依縣市搜尋
              <i class="fa fa-search"></i>
            </h5>
            <div class="col-6">
              <div class="form-group">
                <select @change="town='請選擇鄉鎮市區'" v-model="city" class="form-control" id="city">
                  <option>台北市</option>
                  <option>基隆市</option>
                  <option>新北市</option>
                  <option>連江縣</option>
                  <option>宜蘭縣</option>
                  <option>新竹市</option>
                  <option>新竹縣</option>
                  <option>桃園市</option>
                  <option>苗栗縣</option>
                  <option>臺中市</option>
                  <option>彰化縣</option>
                  <option>南投縣</option>
                  <option>嘉義市</option>
                  <option>嘉義縣</option>
                  <option>雲林縣</option>
                  <option>臺南市</option>
                  <option>高雄市</option>
                  <option>澎湖縣</option>
                  <option>金門縣</option>
                  <option>屏東縣</option>
                  <option>臺東縣</option>
                  <option>花蓮縣</option>
                </select>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <select v-model="town" class="form-control" id="town">
                  <option>請選擇鄉鎮市區</option>
                  <option v-for="(item,index) in townOption" :key="index">{{item.district}}</option>
                </select>
              </div>
            </div>
            <p class="col-12 formTxt" v-if="maskData">
              -該地區共
              <span>{{myData.length}}</span> 家藥局尚有剩餘口罩-
            </p>
          </div>
          <!-- storeData -->
          <div class="storeData container" v-if="maskData">
            <div class="row storeDataFlex">
              <div
                @click="addMark(item)"
                v-for="(item,index) in myData"
                :key="index"
                class="col-md-5 col-12 store"
              >
                <h3 class="storeName">
                  {{item.properties.name}}
                  <i class="fa fa-angle-double-right rightIcon"></i>
                </h3>
                <p class="storeAddress">
                  <i class="fa fa-home"></i>
                  {{item.properties.address}}
                </p>
                <p class="storePhone">
                  <i class="fa fa-phone"></i>
                  {{item.properties.phone}}
                </p>
                <!-- 剩餘口罩 -->
                <div class="row">
                  <div class="col-6">
                    <div class="adultMask">
                      <p>成人口罩</p>
                      <h4>
                        {{item.properties.mask_adult}}
                        <span>個</span>
                      </h4>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="chileMask">
                      <p>兒童口罩</p>
                      <h4>
                        {{item.properties.mask_child}}
                        <span>個</span>
                      </h4>
                    </div>
                  </div>
                </div>

                <p class="storeUpdated">最後更新時間{{item.properties.updated}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-5 mapContainer" :class="{'openMap':openMap}">
          <div id="map"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../src/components/Loader";

export default {
  name: "app",
  components: {
    Loader
  },
  data() {
    return {
      areaData: [
        {
          zip_code: "100",
          district: "中正區",
          city: "台北市",
          lat: 25.0324,
          lng: 121.52
        },
        {
          zip_code: "103",
          district: "大同區",
          city: "台北市",
          lat: 25.0634,
          lng: 121.513
        },
        {
          zip_code: "104",
          district: "中山區",
          city: "台北市",
          lat: 25.0697,
          lng: 121.538
        },
        {
          zip_code: "105",
          district: "松山區",
          city: "台北市",
          lat: 25.06,
          lng: 121.558
        },
        {
          zip_code: "106",
          district: "大安區",
          city: "台北市",
          lat: 25.0268,
          lng: 121.543
        },
        {
          zip_code: "108",
          district: "萬華區",
          city: "台北市",
          lat: 25.0286,
          lng: 121.498
        },
        {
          zip_code: "110",
          district: "信義區",
          city: "台北市",
          lat: 25.0306,
          lng: 121.572
        },
        {
          zip_code: "111",
          district: "士林區",
          city: "台北市",
          lat: 25.1255,
          lng: 121.551
        },
        {
          zip_code: "112",
          district: "北投區",
          city: "台北市",
          lat: 25.1481,
          lng: 121.518
        },
        {
          zip_code: "114",
          district: "內湖區",
          city: "台北市",
          lat: 25.0837,
          lng: 121.592
        },
        {
          zip_code: "115",
          district: "南港區",
          city: "台北市",
          lat: 25.036,
          lng: 121.61
        },
        {
          zip_code: "116",
          district: "文山區",
          city: "台北市",
          lat: 24.9886,
          lng: 121.574
        },
        {
          zip_code: "200",
          district: "仁愛區",
          city: "基隆市",
          lat: 25.1195,
          lng: 121.743
        },
        {
          zip_code: "201",
          district: "信義區",
          city: "基隆市",
          lat: 25.1258,
          lng: 121.773
        },
        {
          zip_code: "202",
          district: "中正區",
          city: "基隆市",
          lat: 25.1437,
          lng: 121.778
        },
        {
          zip_code: "203",
          district: "中山區",
          city: "基隆市",
          lat: 25.1499,
          lng: 121.731
        },
        {
          zip_code: "204",
          district: "安樂區",
          city: "基隆市",
          lat: 25.1414,
          lng: 121.708
        },
        {
          zip_code: "205",
          district: "暖暖區",
          city: "基隆市",
          lat: 25.081,
          lng: 121.745
        },
        {
          zip_code: "206",
          district: "七堵區",
          city: "基隆市",
          lat: 25.1096,
          lng: 121.684
        },
        {
          zip_code: "207",
          district: "萬里區",
          city: "新北市",
          lat: 25.1757,
          lng: 121.644
        },
        {
          zip_code: "208",
          district: "金山區",
          city: "新北市",
          lat: 25.2171,
          lng: 121.605
        },
        {
          zip_code: "209",
          district: "南竿鄉",
          city: "連江縣",
          lat: 26.1543,
          lng: 119.931
        },
        {
          zip_code: "210",
          district: "北竿鄉",
          city: "連江縣",
          lat: 26.2256,
          lng: 119.994
        },
        {
          zip_code: "211",
          district: "莒光鄉",
          city: "連江縣",
          lat: 25.973,
          lng: 119.939
        },
        {
          zip_code: "212",
          district: "東引鄉",
          city: "連江縣",
          lat: 26.3661,
          lng: 120.49
        },
        {
          zip_code: "220",
          district: "板橋區",
          city: "新北市",
          lat: 25.0119,
          lng: 121.458
        },
        {
          zip_code: "221",
          district: "汐止區",
          city: "新北市",
          lat: 25.0733,
          lng: 121.655
        },
        {
          zip_code: "222",
          district: "深坑區",
          city: "新北市",
          lat: 24.9977,
          lng: 121.62
        },
        {
          zip_code: "223",
          district: "石碇區",
          city: "新北市",
          lat: 24.9471,
          lng: 121.647
        },
        {
          zip_code: "224",
          district: "瑞芳區",
          city: "新北市",
          lat: 25.0981,
          lng: 121.823
        },
        {
          zip_code: "226",
          district: "平溪區",
          city: "新北市",
          lat: 25.0261,
          lng: 121.758
        },
        {
          zip_code: "227",
          district: "雙溪區",
          city: "新北市",
          lat: 24.997,
          lng: 121.833
        },
        {
          zip_code: "228",
          district: "貢寮區",
          city: "新北市",
          lat: 25.0249,
          lng: 121.918
        },
        {
          zip_code: "231",
          district: "新店區",
          city: "新北市",
          lat: 24.9304,
          lng: 121.532
        },
        {
          zip_code: "232",
          district: "坪林區",
          city: "新北市",
          lat: 24.911,
          lng: 121.724
        },
        {
          zip_code: "233",
          district: "烏來區",
          city: "新北市",
          lat: 24.7882,
          lng: 121.541
        },
        {
          zip_code: "234",
          district: "永和區",
          city: "新北市",
          lat: 25.0081,
          lng: 121.517
        },
        {
          zip_code: "235",
          district: "中和區",
          city: "新北市",
          lat: 24.9909,
          lng: 121.494
        },
        {
          zip_code: "236",
          district: "土城區",
          city: "新北市",
          lat: 24.9643,
          lng: 121.446
        },
        {
          zip_code: "237",
          district: "三峽區",
          city: "新北市",
          lat: 24.8821,
          lng: 121.416
        },
        {
          zip_code: "238",
          district: "樹林區",
          city: "新北市",
          lat: 24.9797,
          lng: 121.401
        },
        {
          zip_code: "239",
          district: "鶯歌區",
          city: "新北市",
          lat: 24.9566,
          lng: 121.347
        },
        {
          zip_code: "241",
          district: "三重區",
          city: "新北市",
          lat: 25.0628,
          lng: 121.487
        },
        {
          zip_code: "242",
          district: "新莊區",
          city: "新北市",
          lat: 25.0358,
          lng: 121.437
        },
        {
          zip_code: "243",
          district: "泰山區",
          city: "新北市",
          lat: 25.0555,
          lng: 121.416
        },
        {
          zip_code: "244",
          district: "林口區",
          city: "新北市",
          lat: 25.1001,
          lng: 121.353
        },
        {
          zip_code: "247",
          district: "蘆洲區",
          city: "新北市",
          lat: 25.0893,
          lng: 121.471
        },
        {
          zip_code: "248",
          district: "五股區",
          city: "新北市",
          lat: 25.0961,
          lng: 121.433
        },
        {
          zip_code: "249",
          district: "八里區",
          city: "新北市",
          lat: 25.1381,
          lng: 121.414
        },
        {
          zip_code: "251",
          district: "淡水區",
          city: "新北市",
          lat: 25.1891,
          lng: 121.464
        },
        {
          zip_code: "252",
          district: "三芝區",
          city: "新北市",
          lat: 25.2316,
          lng: 121.516
        },
        {
          zip_code: "253",
          district: "石門區",
          city: "新北市",
          lat: 25.2652,
          lng: 121.569
        },
        {
          zip_code: "260",
          district: "宜蘭市",
          city: "宜蘭縣",
          lat: 24.7502,
          lng: 121.757
        },
        {
          zip_code: "261",
          district: "頭城鎮",
          city: "宜蘭縣",
          lat: 24.9008,
          lng: 121.846
        },
        {
          zip_code: "262",
          district: "礁溪鄉",
          city: "宜蘭縣",
          lat: 24.8114,
          lng: 121.735
        },
        {
          zip_code: "263",
          district: "壯圍鄉",
          city: "宜蘭縣",
          lat: 24.7518,
          lng: 121.802
        },
        {
          zip_code: "264",
          district: "員山鄉",
          city: "宜蘭縣",
          lat: 24.742,
          lng: 121.661
        },
        {
          zip_code: "265",
          district: "羅東鎮",
          city: "宜蘭縣",
          lat: 24.6788,
          lng: 121.77
        },
        {
          zip_code: "266",
          district: "三星鄉",
          city: "宜蘭縣",
          lat: 24.6677,
          lng: 121.664
        },
        {
          zip_code: "267",
          district: "大同鄉",
          city: "宜蘭縣",
          lat: 24.5515,
          lng: 121.504
        },
        {
          zip_code: "268",
          district: "五結鄉",
          city: "宜蘭縣",
          lat: 24.6889,
          lng: 121.806
        },
        {
          zip_code: "269",
          district: "冬山鄉",
          city: "宜蘭縣",
          lat: 24.6421,
          lng: 121.76
        },
        {
          zip_code: "270",
          district: "蘇澳鎮",
          city: "宜蘭縣",
          lat: 24.5547,
          lng: 121.835
        },
        {
          zip_code: "272",
          district: "南澳鄉",
          city: "宜蘭縣",
          lat: 24.4486,
          lng: 121.656
        },
        {
          zip_code: "290",
          district: "釣魚臺列嶼",
          city: "宜蘭縣",
          lat: 25.7464,
          lng: 123.475
        },
        {
          zip_code: "300",
          district: "東區",
          city: "新竹市",
          lat: 24.7903,
          lng: 120.993
        },
        {
          zip_code: "300",
          district: "北區",
          city: "新竹市",
          lat: 24.8227,
          lng: 120.949
        },
        {
          zip_code: "300",
          district: "香山區",
          city: "新竹市",
          lat: 24.771,
          lng: 120.924
        },
        {
          zip_code: "302",
          district: "竹北市",
          city: "新竹縣",
          lat: 24.8382,
          lng: 120.995
        },
        {
          zip_code: "303",
          district: "湖口鄉",
          city: "新竹縣",
          lat: 24.8857,
          lng: 121.052
        },
        {
          zip_code: "304",
          district: "新豐鄉",
          city: "新竹縣",
          lat: 24.9073,
          lng: 120.996
        },
        {
          zip_code: "305",
          district: "新埔鎮",
          city: "新竹縣",
          lat: 24.8413,
          lng: 121.094
        },
        {
          zip_code: "306",
          district: "關西鎮",
          city: "新竹縣",
          lat: 24.7851,
          lng: 121.187
        },
        {
          zip_code: "307",
          district: "芎林鄉",
          city: "新竹縣",
          lat: 24.7657,
          lng: 121.105
        },
        {
          zip_code: "308",
          district: "寶山鄉",
          city: "新竹縣",
          lat: 24.737,
          lng: 120.999
        },
        {
          zip_code: "310",
          district: "竹東鎮",
          city: "新竹縣",
          lat: 24.7308,
          lng: 121.075
        },
        {
          zip_code: "311",
          district: "五峰鄉",
          city: "新竹縣",
          lat: 24.5781,
          lng: 121.139
        },
        {
          zip_code: "312",
          district: "橫山鄉",
          city: "新竹縣",
          lat: 24.7078,
          lng: 121.147
        },
        {
          zip_code: "313",
          district: "尖石鄉",
          city: "新竹縣",
          lat: 24.5949,
          lng: 121.282
        },
        {
          zip_code: "314",
          district: "北埔鄉",
          city: "新竹縣",
          lat: 24.6721,
          lng: 121.064
        },
        {
          zip_code: "315",
          district: "峨嵋鄉",
          city: "新竹縣",
          lat: 24.6781,
          lng: 121.011
        },
        {
          zip_code: "320",
          district: "中壢區",
          city: "桃園市",
          lat: 24.9799,
          lng: 121.215
        },
        {
          zip_code: "324",
          district: "平鎮區",
          city: "桃園市",
          lat: 24.9212,
          lng: 121.214
        },
        {
          zip_code: "325",
          district: "龍潭區",
          city: "桃園市",
          lat: 24.8506,
          lng: 121.212
        },
        {
          zip_code: "326",
          district: "楊梅區",
          city: "桃園市",
          lat: 24.9182,
          lng: 121.129
        },
        {
          zip_code: "327",
          district: "新屋區",
          city: "桃園市",
          lat: 24.9728,
          lng: 121.068
        },
        {
          zip_code: "328",
          district: "觀音區",
          city: "桃園市",
          lat: 25.0267,
          lng: 121.116
        },
        {
          zip_code: "330",
          district: "桃園區",
          city: "桃園市",
          lat: 25.0004,
          lng: 121.3
        },
        {
          zip_code: "333",
          district: "龜山區",
          city: "桃園市",
          lat: 25.0242,
          lng: 121.357
        },
        {
          zip_code: "334",
          district: "八德區",
          city: "桃園市",
          lat: 24.9497,
          lng: 121.291
        },
        {
          zip_code: "335",
          district: "大溪區",
          city: "桃園市",
          lat: 24.868,
          lng: 121.296
        },
        {
          zip_code: "336",
          district: "復興區",
          city: "桃園市",
          lat: 24.7295,
          lng: 121.375
        },
        {
          zip_code: "337",
          district: "大園區",
          city: "桃園市",
          lat: 25.0638,
          lng: 121.212
        },
        {
          zip_code: "338",
          district: "蘆竹區",
          city: "桃園市",
          lat: 25.0607,
          lng: 121.283
        },
        {
          zip_code: "350",
          district: "竹南鎮",
          city: "苗栗縣",
          lat: 24.6986,
          lng: 120.878
        },
        {
          zip_code: "351",
          district: "頭份鎮",
          city: "苗栗縣",
          lat: 24.6763,
          lng: 120.919
        },
        {
          zip_code: "352",
          district: "三灣鄉",
          city: "苗栗縣",
          lat: 24.636,
          lng: 120.953
        },
        {
          zip_code: "353",
          district: "南庄鄉",
          city: "苗栗縣",
          lat: 24.5661,
          lng: 121.017
        },
        {
          zip_code: "354",
          district: "獅潭鄉",
          city: "苗栗縣",
          lat: 24.5198,
          lng: 120.921
        },
        {
          zip_code: "356",
          district: "後龍鎮",
          city: "苗栗縣",
          lat: 24.6156,
          lng: 120.781
        },
        {
          zip_code: "357",
          district: "通霄鎮",
          city: "苗栗縣",
          lat: 24.485,
          lng: 120.715
        },
        {
          zip_code: "358",
          district: "苑裡鎮",
          city: "苗栗縣",
          lat: 24.411,
          lng: 120.688
        },
        {
          zip_code: "360",
          district: "苗栗市",
          city: "苗栗縣",
          lat: 24.5638,
          lng: 120.811
        },
        {
          zip_code: "361",
          district: "造橋鄉",
          city: "苗栗縣",
          lat: 24.6248,
          lng: 120.87
        },
        {
          zip_code: "362",
          district: "頭屋鄉",
          city: "苗栗縣",
          lat: 24.5735,
          lng: 120.883
        },
        {
          zip_code: "363",
          district: "公館鄉",
          city: "苗栗縣",
          lat: 24.5025,
          lng: 120.851
        },
        {
          zip_code: "364",
          district: "大湖鄉",
          city: "苗栗縣",
          lat: 24.3936,
          lng: 120.863
        },
        {
          zip_code: "365",
          district: "泰安鄉",
          city: "苗栗縣",
          lat: 24.4193,
          lng: 121.068
        },
        {
          zip_code: "366",
          district: "銅鑼鄉",
          city: "苗栗縣",
          lat: 24.4559,
          lng: 120.799
        },
        {
          zip_code: "367",
          district: "三義鄉",
          city: "苗栗縣",
          lat: 24.3808,
          lng: 120.77
        },
        {
          zip_code: "368",
          district: "西湖鄉",
          city: "苗栗縣",
          lat: 24.5415,
          lng: 120.761
        },
        {
          zip_code: "369",
          district: "卓蘭鎮",
          city: "苗栗縣",
          lat: 24.3251,
          lng: 120.856
        },
        {
          zip_code: "400",
          district: "中區",
          city: "臺中市",
          lat: 24.1417,
          lng: 120.681
        },
        {
          zip_code: "401",
          district: "東區",
          city: "臺中市",
          lat: 24.1373,
          lng: 120.697
        },
        {
          zip_code: "402",
          district: "南區",
          city: "臺中市",
          lat: 24.1211,
          lng: 120.665
        },
        {
          zip_code: "403",
          district: "西區",
          city: "臺中市",
          lat: 24.1439,
          lng: 120.665
        },
        {
          zip_code: "404",
          district: "北區",
          city: "臺中市",
          lat: 24.1586,
          lng: 120.681
        },
        {
          zip_code: "406",
          district: "北屯區",
          city: "臺中市",
          lat: 24.184,
          lng: 120.736
        },
        {
          zip_code: "407",
          district: "西屯區",
          city: "臺中市",
          lat: 24.1831,
          lng: 120.627
        },
        {
          zip_code: "408",
          district: "南屯區",
          city: "臺中市",
          lat: 24.1417,
          lng: 120.618
        },
        {
          zip_code: "411",
          district: "太平區",
          city: "臺中市",
          lat: 24.1148,
          lng: 120.773
        },
        {
          zip_code: "412",
          district: "大里區",
          city: "臺中市",
          lat: 24.0958,
          lng: 120.693
        },
        {
          zip_code: "413",
          district: "霧峰區",
          city: "臺中市",
          lat: 24.0433,
          lng: 120.72
        },
        {
          zip_code: "414",
          district: "烏日區",
          city: "臺中市",
          lat: 24.0839,
          lng: 120.629
        },
        {
          zip_code: "420",
          district: "豐原區",
          city: "臺中市",
          lat: 24.2499,
          lng: 120.738
        },
        {
          zip_code: "421",
          district: "后里區",
          city: "臺中市",
          lat: 24.3096,
          lng: 120.715
        },
        {
          zip_code: "422",
          district: "石岡區",
          city: "臺中市",
          lat: 24.2649,
          lng: 120.79
        },
        {
          zip_code: "423",
          district: "東勢區",
          city: "臺中市",
          lat: 24.2495,
          lng: 120.84
        },
        {
          zip_code: "424",
          district: "和平區",
          city: "臺中市",
          lat: 24.2762,
          lng: 121.14
        },
        {
          zip_code: "426",
          district: "新社區",
          city: "臺中市",
          lat: 24.1777,
          lng: 120.831
        },
        {
          zip_code: "427",
          district: "潭子區",
          city: "臺中市",
          lat: 24.2117,
          lng: 120.711
        },
        {
          zip_code: "428",
          district: "大雅區",
          city: "臺中市",
          lat: 24.227,
          lng: 120.641
        },
        {
          zip_code: "429",
          district: "神岡區",
          city: "臺中市",
          lat: 24.2657,
          lng: 120.673
        },
        {
          zip_code: "432",
          district: "大肚區",
          city: "臺中市",
          lat: 24.1447,
          lng: 120.554
        },
        {
          zip_code: "433",
          district: "沙鹿區",
          city: "臺中市",
          lat: 24.2343,
          lng: 120.584
        },
        {
          zip_code: "434",
          district: "龍井區",
          city: "臺中市",
          lat: 24.2006,
          lng: 120.528
        },
        {
          zip_code: "435",
          district: "梧棲區",
          city: "臺中市",
          lat: 24.2455,
          lng: 120.53
        },
        {
          zip_code: "436",
          district: "清水區",
          city: "臺中市",
          lat: 24.2921,
          lng: 120.581
        },
        {
          zip_code: "437",
          district: "大甲區",
          city: "臺中市",
          lat: 24.3783,
          lng: 120.636
        },
        {
          zip_code: "438",
          district: "外埔區",
          city: "臺中市",
          lat: 24.3355,
          lng: 120.665
        },
        {
          zip_code: "439",
          district: "大安區",
          city: "臺中市",
          lat: 24.3651,
          lng: 120.591
        },
        {
          zip_code: "500",
          district: "彰化市",
          city: "彰化縣",
          lat: 24.0753,
          lng: 120.569
        },
        {
          zip_code: "502",
          district: "芬園鄉",
          city: "彰化縣",
          lat: 24.0063,
          lng: 120.629
        },
        {
          zip_code: "503",
          district: "花壇鄉",
          city: "彰化縣",
          lat: 24.0301,
          lng: 120.56
        },
        {
          zip_code: "504",
          district: "秀水鄉",
          city: "彰化縣",
          lat: 24.0325,
          lng: 120.504
        },
        {
          zip_code: "505",
          district: "鹿港鎮",
          city: "彰化縣",
          lat: 24.0829,
          lng: 120.439
        },
        {
          zip_code: "506",
          district: "福興鄉",
          city: "彰化縣",
          lat: 24.0302,
          lng: 120.431
        },
        {
          zip_code: "507",
          district: "線西鄉",
          city: "彰化縣",
          lat: 24.1316,
          lng: 120.452
        },
        {
          zip_code: "508",
          district: "和美鎮",
          city: "彰化縣",
          lat: 24.1138,
          lng: 120.511
        },
        {
          zip_code: "509",
          district: "伸港鄉",
          city: "彰化縣",
          lat: 24.1637,
          lng: 120.486
        },
        {
          zip_code: "510",
          district: "員林鎮",
          city: "彰化縣",
          lat: 23.9565,
          lng: 120.593
        },
        {
          zip_code: "511",
          district: "社頭鄉",
          city: "彰化縣",
          lat: 23.9054,
          lng: 120.602
        },
        {
          zip_code: "512",
          district: "永靖鄉",
          city: "彰化縣",
          lat: 23.9214,
          lng: 120.542
        },
        {
          zip_code: "513",
          district: "埔心鄉",
          city: "彰化縣",
          lat: 23.9528,
          lng: 120.534
        },
        {
          zip_code: "514",
          district: "溪湖鎮",
          city: "彰化縣",
          lat: 23.9517,
          lng: 120.483
        },
        {
          zip_code: "515",
          district: "大村鄉",
          city: "彰化縣",
          lat: 23.9921,
          lng: 120.559
        },
        {
          zip_code: "516",
          district: "埔鹽鄉",
          city: "彰化縣",
          lat: 23.992,
          lng: 120.459
        },
        {
          zip_code: "520",
          district: "田中鎮",
          city: "彰化縣",
          lat: 23.8572,
          lng: 120.59
        },
        {
          zip_code: "521",
          district: "北斗鎮",
          city: "彰化縣",
          lat: 23.8676,
          lng: 120.533
        },
        {
          zip_code: "522",
          district: "田尾鄉",
          city: "彰化縣",
          lat: 23.9006,
          lng: 120.522
        },
        {
          zip_code: "523",
          district: "埤頭鄉",
          city: "彰化縣",
          lat: 23.8823,
          lng: 120.468
        },
        {
          zip_code: "524",
          district: "溪州鄉",
          city: "彰化縣",
          lat: 23.8273,
          lng: 120.522
        },
        {
          zip_code: "525",
          district: "竹塘鄉",
          city: "彰化縣",
          lat: 23.8506,
          lng: 120.414
        },
        {
          zip_code: "526",
          district: "二林鎮",
          city: "彰化縣",
          lat: 23.9162,
          lng: 120.404
        },
        {
          zip_code: "527",
          district: "大城鄉",
          city: "彰化縣",
          lat: 23.8507,
          lng: 120.311
        },
        {
          zip_code: "528",
          district: "芳苑鄉",
          city: "彰化縣",
          lat: 23.9538,
          lng: 120.354
        },
        {
          zip_code: "530",
          district: "二水鄉",
          city: "彰化縣",
          lat: 23.8092,
          lng: 120.629
        },
        {
          zip_code: "540",
          district: "南投市",
          city: "南投縣",
          lat: 23.9217,
          lng: 120.679
        },
        {
          zip_code: "541",
          district: "中寮鄉",
          city: "南投縣",
          lat: 23.9059,
          lng: 120.786
        },
        {
          zip_code: "542",
          district: "草屯鎮",
          city: "南投縣",
          lat: 23.9832,
          lng: 120.733
        },
        {
          zip_code: "544",
          district: "國姓鄉",
          city: "南投縣",
          lat: 24.0314,
          lng: 120.868
        },
        {
          zip_code: "545",
          district: "埔里鎮",
          city: "南投縣",
          lat: 23.9789,
          lng: 120.963
        },
        {
          zip_code: "546",
          district: "仁愛鄉",
          city: "南投縣",
          lat: 24.0289,
          lng: 121.144
        },
        {
          zip_code: "551",
          district: "名間鄉",
          city: "南投縣",
          lat: 23.8511,
          lng: 120.677
        },
        {
          zip_code: "552",
          district: "集集鎮",
          city: "南投縣",
          lat: 23.837,
          lng: 120.785
        },
        {
          zip_code: "553",
          district: "水里鄉",
          city: "南投縣",
          lat: 23.7961,
          lng: 120.862
        },
        {
          zip_code: "555",
          district: "魚池鄉",
          city: "南投縣",
          lat: 23.876,
          lng: 120.926
        },
        {
          zip_code: "556",
          district: "信義鄉",
          city: "南投縣",
          lat: 23.6555,
          lng: 121.021
        },
        {
          zip_code: "557",
          district: "竹山鎮",
          city: "南投縣",
          lat: 23.6981,
          lng: 120.71
        },
        {
          zip_code: "558",
          district: "鹿谷鄉",
          city: "南投縣",
          lat: 23.7378,
          lng: 120.782
        },
        {
          zip_code: "600",
          district: "東區",
          city: "嘉義市",
          lat: 23.4817,
          lng: 120.471
        },
        {
          zip_code: "600",
          district: "西區",
          city: "嘉義市",
          lat: 0,
          lng: 0
        },
        {
          zip_code: "602",
          district: "番路鄉",
          city: "嘉義縣",
          lat: 23.4277,
          lng: 120.608
        },
        {
          zip_code: "603",
          district: "梅山鄉",
          city: "嘉義縣",
          lat: 23.5554,
          lng: 120.639
        },
        {
          zip_code: "604",
          district: "竹崎鄉",
          city: "嘉義縣",
          lat: 23.5038,
          lng: 120.597
        },
        {
          zip_code: "605",
          district: "阿里山",
          city: "嘉義縣",
          lat: 23.4408,
          lng: 120.76
        },
        {
          zip_code: "606",
          district: "中埔鄉",
          city: "嘉義縣",
          lat: 23.4041,
          lng: 120.537
        },
        {
          zip_code: "607",
          district: "大埔鄉",
          city: "嘉義縣",
          lat: 23.2885,
          lng: 120.59
        },
        {
          zip_code: "608",
          district: "水上鄉",
          city: "嘉義縣",
          lat: 23.4291,
          lng: 120.415
        },
        {
          zip_code: "611",
          district: "鹿草鄉",
          city: "嘉義縣",
          lat: 23.4081,
          lng: 120.305
        },
        {
          zip_code: "612",
          district: "太保市",
          city: "嘉義縣",
          lat: 23.4729,
          lng: 120.344
        },
        {
          zip_code: "613",
          district: "朴子市",
          city: "嘉義縣",
          lat: 23.4461,
          lng: 120.254
        },
        {
          zip_code: "614",
          district: "東石鄉",
          city: "嘉義縣",
          lat: 23.4687,
          lng: 120.174
        },
        {
          zip_code: "615",
          district: "六腳鄉",
          city: "嘉義縣",
          lat: 23.5102,
          lng: 120.271
        },
        {
          zip_code: "616",
          district: "新港鄉",
          city: "嘉義縣",
          lat: 23.5458,
          lng: 120.348
        },
        {
          zip_code: "621",
          district: "民雄鄉",
          city: "嘉義縣",
          lat: 23.5426,
          lng: 120.444
        },
        {
          zip_code: "622",
          district: "大林鎮",
          city: "嘉義縣",
          lat: 23.5989,
          lng: 120.481
        },
        {
          zip_code: "623",
          district: "溪口鄉",
          city: "嘉義縣",
          lat: 23.5935,
          lng: 120.401
        },
        {
          zip_code: "624",
          district: "義竹鄉",
          city: "嘉義縣",
          lat: 23.3458,
          lng: 120.224
        },
        {
          zip_code: "625",
          district: "布袋鎮",
          city: "嘉義縣",
          lat: 23.3749,
          lng: 120.178
        },
        {
          zip_code: "630",
          district: "斗南鎮",
          city: "雲林縣",
          lat: 23.6707,
          lng: 120.483
        },
        {
          zip_code: "631",
          district: "大埤鄉",
          city: "雲林縣",
          lat: 23.6456,
          lng: 120.426
        },
        {
          zip_code: "632",
          district: "虎尾鎮",
          city: "雲林縣",
          lat: 23.7166,
          lng: 120.429
        },
        {
          zip_code: "633",
          district: "土庫鎮",
          city: "雲林縣",
          lat: 23.6911,
          lng: 120.365
        },
        {
          zip_code: "634",
          district: "褒忠鄉",
          city: "雲林縣",
          lat: 23.7161,
          lng: 120.312
        },
        {
          zip_code: "635",
          district: "東勢鄉",
          city: "雲林縣",
          lat: 23.6961,
          lng: 120.256
        },
        {
          zip_code: "636",
          district: "臺西鄉",
          city: "雲林縣",
          lat: 23.716,
          lng: 120.205
        },
        {
          zip_code: "637",
          district: "崙背鄉",
          city: "雲林縣",
          lat: 23.7785,
          lng: 120.334
        },
        {
          zip_code: "638",
          district: "麥寮鄉",
          city: "雲林縣",
          lat: 23.7882,
          lng: 120.244
        },
        {
          zip_code: "640",
          district: "斗六市",
          city: "雲林縣",
          lat: 23.7065,
          lng: 120.56
        },
        {
          zip_code: "643",
          district: "林內鄉",
          city: "雲林縣",
          lat: 23.7557,
          lng: 120.616
        },
        {
          zip_code: "646",
          district: "古坑鄉",
          city: "雲林縣",
          lat: 23.6255,
          lng: 120.612
        },
        {
          zip_code: "647",
          district: "莿桐鄉",
          city: "雲林縣",
          lat: 23.7697,
          lng: 120.529
        },
        {
          zip_code: "648",
          district: "西螺鎮",
          city: "雲林縣",
          lat: 23.7794,
          lng: 120.458
        },
        {
          zip_code: "649",
          district: "二崙鄉",
          city: "雲林縣",
          lat: 23.7926,
          lng: 120.396
        },
        {
          zip_code: "651",
          district: "北港鎮",
          city: "雲林縣",
          lat: 23.5922,
          lng: 120.294
        },
        {
          zip_code: "652",
          district: "水林鄉",
          city: "雲林縣",
          lat: 23.5616,
          lng: 120.235
        },
        {
          zip_code: "653",
          district: "口湖鄉",
          city: "雲林縣",
          lat: 23.5537,
          lng: 120.141
        },
        {
          zip_code: "654",
          district: "四湖鄉",
          city: "雲林縣",
          lat: 23.6421,
          lng: 120.206
        },
        {
          zip_code: "655",
          district: "元長鄉",
          city: "雲林縣",
          lat: 23.6424,
          lng: 120.328
        },
        {
          zip_code: "700",
          district: "中西區",
          city: "臺南市",
          lat: 22.9959,
          lng: 120.193
        },
        {
          zip_code: "701",
          district: "東區",
          city: "臺南市",
          lat: 22.9818,
          lng: 120.228
        },
        {
          zip_code: "702",
          district: "南區",
          city: "臺南市",
          lat: 22.9556,
          lng: 120.19
        },
        {
          zip_code: "704",
          district: "北區",
          city: "臺南市",
          lat: 23.0101,
          lng: 120.207
        },
        {
          zip_code: "708",
          district: "安平區",
          city: "臺南市",
          lat: 22.9901,
          lng: 120.165
        },
        {
          zip_code: "709",
          district: "安南區",
          city: "臺南市",
          lat: 23.0487,
          lng: 120.153
        },
        {
          zip_code: "710",
          district: "永康區",
          city: "臺南市",
          lat: 23.0273,
          lng: 120.254
        },
        {
          zip_code: "711",
          district: "歸仁區",
          city: "臺南市",
          lat: 22.9468,
          lng: 120.293
        },
        {
          zip_code: "712",
          district: "新化區",
          city: "臺南市",
          lat: 23.0339,
          lng: 120.336
        },
        {
          zip_code: "713",
          district: "左鎮區",
          city: "臺南市",
          lat: 23.026,
          lng: 120.412
        },
        {
          zip_code: "714",
          district: "玉井區",
          city: "臺南市",
          lat: 23.1148,
          lng: 120.461
        },
        {
          zip_code: "715",
          district: "楠西區",
          city: "臺南市",
          lat: 23.1789,
          lng: 120.517
        },
        {
          zip_code: "716",
          district: "南化區",
          city: "臺南市",
          lat: 23.1151,
          lng: 120.544
        },
        {
          zip_code: "717",
          district: "仁德區",
          city: "臺南市",
          lat: 22.9413,
          lng: 120.242
        },
        {
          zip_code: "718",
          district: "關廟區",
          city: "臺南市",
          lat: 22.9558,
          lng: 120.334
        },
        {
          zip_code: "719",
          district: "龍崎區",
          city: "臺南市",
          lat: 22.9548,
          lng: 120.387
        },
        {
          zip_code: "720",
          district: "官田區",
          city: "臺南市",
          lat: 23.191,
          lng: 120.348
        },
        {
          zip_code: "721",
          district: "麻豆區",
          city: "臺南市",
          lat: 23.1825,
          lng: 120.241
        },
        {
          zip_code: "722",
          district: "佳里區",
          city: "臺南市",
          lat: 23.167,
          lng: 120.179
        },
        {
          zip_code: "723",
          district: "西港區",
          city: "臺南市",
          lat: 23.1249,
          lng: 120.2
        },
        {
          zip_code: "724",
          district: "七股區",
          city: "臺南市",
          lat: 23.1233,
          lng: 120.101
        },
        {
          zip_code: "725",
          district: "將軍區",
          city: "臺南市",
          lat: 23.2083,
          lng: 120.128
        },
        {
          zip_code: "726",
          district: "學甲區",
          city: "臺南市",
          lat: 23.2522,
          lng: 120.184
        },
        {
          zip_code: "727",
          district: "北門區",
          city: "臺南市",
          lat: 23.2778,
          lng: 120.126
        },
        {
          zip_code: "730",
          district: "新營區",
          city: "臺南市",
          lat: 23.3015,
          lng: 120.295
        },
        {
          zip_code: "731",
          district: "後壁區",
          city: "臺南市",
          lat: 23.362,
          lng: 120.349
        },
        {
          zip_code: "732",
          district: "白河區",
          city: "臺南市",
          lat: 23.3513,
          lng: 120.458
        },
        {
          zip_code: "733",
          district: "東山區",
          city: "臺南市",
          lat: 23.2783,
          lng: 120.444
        },
        {
          zip_code: "734",
          district: "六甲區",
          city: "臺南市",
          lat: 23.2273,
          lng: 120.38
        },
        {
          zip_code: "735",
          district: "下營區",
          city: "臺南市",
          lat: 23.231,
          lng: 120.265
        },
        {
          zip_code: "736",
          district: "柳營區",
          city: "臺南市",
          lat: 23.2689,
          lng: 120.355
        },
        {
          zip_code: "737",
          district: "鹽水區",
          city: "臺南市",
          lat: 23.298,
          lng: 120.248
        },
        {
          zip_code: "741",
          district: "善化區",
          city: "臺南市",
          lat: 23.1403,
          lng: 120.299
        },
        {
          zip_code: "742",
          district: "大內區",
          city: "臺南市",
          lat: 23.1448,
          lng: 120.399
        },
        {
          zip_code: "743",
          district: "山上區",
          city: "臺南市",
          lat: 23.0969,
          lng: 120.371
        },
        {
          zip_code: "744",
          district: "新市區",
          city: "臺南市",
          lat: 23.0832,
          lng: 120.292
        },
        {
          zip_code: "745",
          district: "安定區",
          city: "臺南市",
          lat: 23.0997,
          lng: 120.23
        },
        {
          zip_code: "800",
          district: "新興區",
          city: "高雄市",
          lat: 22.6299,
          lng: 120.307
        },
        {
          zip_code: "801",
          district: "前金區",
          city: "高雄市",
          lat: 22.627,
          lng: 120.294
        },
        {
          zip_code: "802",
          district: "苓雅區",
          city: "高雄市",
          lat: 22.6236,
          lng: 120.321
        },
        {
          zip_code: "803",
          district: "鹽埕區",
          city: "高雄市",
          lat: 22.6242,
          lng: 120.284
        },
        {
          zip_code: "804",
          district: "鼓山區",
          city: "高雄市",
          lat: 22.6502,
          lng: 120.274
        },
        {
          zip_code: "805",
          district: "旗津區",
          city: "高雄市",
          lat: 22.5857,
          lng: 120.289
        },
        {
          zip_code: "806",
          district: "前鎮區",
          city: "高雄市",
          lat: 22.5927,
          lng: 120.315
        },
        {
          zip_code: "807",
          district: "三民區",
          city: "高雄市",
          lat: 22.6499,
          lng: 120.318
        },
        {
          zip_code: "811",
          district: "楠梓區",
          city: "高雄市",
          lat: 22.7211,
          lng: 120.301
        },
        {
          zip_code: "812",
          district: "小港區",
          city: "高雄市",
          lat: 22.5514,
          lng: 120.359
        },
        {
          zip_code: "813",
          district: "左營區",
          city: "高雄市",
          lat: 22.684,
          lng: 120.295
        },
        {
          zip_code: "814",
          district: "仁武區",
          city: "高雄市",
          lat: 22.7012,
          lng: 120.361
        },
        {
          zip_code: "815",
          district: "大社區",
          city: "高雄市",
          lat: 22.7398,
          lng: 120.371
        },
        {
          zip_code: "820",
          district: "岡山區",
          city: "高雄市",
          lat: 22.8051,
          lng: 120.298
        },
        {
          zip_code: "821",
          district: "路竹區",
          city: "高雄市",
          lat: 22.8572,
          lng: 120.266
        },
        {
          zip_code: "822",
          district: "阿蓮區",
          city: "高雄市",
          lat: 22.8702,
          lng: 120.321
        },
        {
          zip_code: "823",
          district: "田寮鄉",
          city: "高雄市",
          lat: 22.8639,
          lng: 120.396
        },
        {
          zip_code: "824",
          district: "燕巢區",
          city: "高雄市",
          lat: 22.7877,
          lng: 120.371
        },
        {
          zip_code: "825",
          district: "橋頭區",
          city: "高雄市",
          lat: 22.7525,
          lng: 120.301
        },
        {
          zip_code: "826",
          district: "梓官區",
          city: "高雄市",
          lat: 22.7482,
          lng: 120.259
        },
        {
          zip_code: "827",
          district: "彌陀區",
          city: "高雄市",
          lat: 22.7794,
          lng: 120.239
        },
        {
          zip_code: "828",
          district: "永安區",
          city: "高雄市",
          lat: 22.8222,
          lng: 120.228
        },
        {
          zip_code: "829",
          district: "湖內鄉",
          city: "高雄市",
          lat: 22.8932,
          lng: 120.226
        },
        {
          zip_code: "830",
          district: "鳳山區",
          city: "高雄市",
          lat: 22.6138,
          lng: 120.355
        },
        {
          zip_code: "831",
          district: "大寮區",
          city: "高雄市",
          lat: 22.5928,
          lng: 120.411
        },
        {
          zip_code: "832",
          district: "林園區",
          city: "高雄市",
          lat: 22.5081,
          lng: 120.399
        },
        {
          zip_code: "833",
          district: "鳥松區",
          city: "高雄市",
          lat: 22.6625,
          lng: 120.373
        },
        {
          zip_code: "840",
          district: "大樹區",
          city: "高雄市",
          lat: 22.711,
          lng: 120.425
        },
        {
          zip_code: "842",
          district: "旗山區",
          city: "高雄市",
          lat: 22.865,
          lng: 120.475
        },
        {
          zip_code: "843",
          district: "美濃區",
          city: "高雄市",
          lat: 22.9001,
          lng: 120.563
        },
        {
          zip_code: "844",
          district: "六龜區",
          city: "高雄市",
          lat: 23.012,
          lng: 120.659
        },
        {
          zip_code: "845",
          district: "內門區",
          city: "高雄市",
          lat: 22.9567,
          lng: 120.472
        },
        {
          zip_code: "846",
          district: "杉林區",
          city: "高雄市",
          lat: 22.9969,
          lng: 120.562
        },
        {
          zip_code: "847",
          district: "甲仙區",
          city: "高雄市",
          lat: 23.1166,
          lng: 120.623
        },
        {
          zip_code: "848",
          district: "桃源區",
          city: "高雄市",
          lat: 23.2249,
          lng: 120.852
        },
        {
          zip_code: "849",
          district: "那瑪夏區",
          city: "高雄市",
          lat: 23.275,
          lng: 120.742
        },
        {
          zip_code: "851",
          district: "茂林區",
          city: "高雄市",
          lat: 22.9199,
          lng: 120.752
        },
        {
          zip_code: "852",
          district: "茄萣區",
          city: "高雄市",
          lat: 22.8824,
          lng: 120.198
        },
        {
          zip_code: "880",
          district: "馬公市",
          city: "澎湖縣",
          lat: 23.5553,
          lng: 119.592
        },
        {
          zip_code: "881",
          district: "西嶼鄉",
          city: "澎湖縣",
          lat: 23.5998,
          lng: 119.508
        },
        {
          zip_code: "882",
          district: "望安鄉",
          city: "澎湖縣",
          lat: 23.369,
          lng: 119.504
        },
        {
          zip_code: "883",
          district: "七美鄉",
          city: "澎湖縣",
          lat: 23.2011,
          lng: 119.434
        },
        {
          zip_code: "884",
          district: "白沙鄉",
          city: "澎湖縣",
          lat: 23.6418,
          lng: 119.593
        },
        {
          zip_code: "885",
          district: "湖西鄉",
          city: "澎湖縣",
          lat: 23.5736,
          lng: 119.645
        },
        {
          zip_code: "890",
          district: "金沙鎮",
          city: "金門縣",
          lat: 24.4587,
          lng: 118.408
        },
        {
          zip_code: "891",
          district: "金湖鎮",
          city: "金門縣",
          lat: 24.415,
          lng: 118.404
        },
        {
          zip_code: "892",
          district: "金寧鄉",
          city: "金門縣",
          lat: 24.4248,
          lng: 118.317
        },
        {
          zip_code: "893",
          district: "金城鎮",
          city: "金門縣",
          lat: 24.384,
          lng: 118.301
        },
        {
          zip_code: "894",
          district: "烈嶼鄉",
          city: "金門縣",
          lat: 24.4017,
          lng: 118.228
        },
        {
          zip_code: "896",
          district: "烏坵鄉",
          city: "金門縣",
          lat: 24.9923,
          lng: 119.453
        },
        {
          zip_code: "900",
          district: "屏東市",
          city: "屏東縣",
          lat: 22.6647,
          lng: 120.48
        },
        {
          zip_code: "901",
          district: "三地門",
          city: "屏東縣",
          lat: 22.7979,
          lng: 120.687
        },
        {
          zip_code: "902",
          district: "霧臺鄉",
          city: "屏東縣",
          lat: 22.7599,
          lng: 120.801
        },
        {
          zip_code: "903",
          district: "瑪家鄉",
          city: "屏東縣",
          lat: 22.6711,
          lng: 120.68
        },
        {
          zip_code: "904",
          district: "九如鄉",
          city: "屏東縣",
          lat: 22.7317,
          lng: 120.485
        },
        {
          zip_code: "905",
          district: "里港鄉",
          city: "屏東縣",
          lat: 22.7985,
          lng: 120.506
        },
        {
          zip_code: "906",
          district: "高樹鄉",
          city: "屏東縣",
          lat: 22.8099,
          lng: 120.602
        },
        {
          zip_code: "907",
          district: "鹽埔鄉",
          city: "屏東縣",
          lat: 22.7425,
          lng: 120.569
        },
        {
          zip_code: "908",
          district: "長治鄉",
          city: "屏東縣",
          lat: 22.6945,
          lng: 120.556
        },
        {
          zip_code: "909",
          district: "麟洛鄉",
          city: "屏東縣",
          lat: 22.6488,
          lng: 120.53
        },
        {
          zip_code: "911",
          district: "竹田鄉",
          city: "屏東縣",
          lat: 22.5886,
          lng: 120.527
        },
        {
          zip_code: "912",
          district: "內埔鄉",
          city: "屏東縣",
          lat: 22.6512,
          lng: 120.589
        },
        {
          zip_code: "913",
          district: "萬丹鄉",
          city: "屏東縣",
          lat: 22.5885,
          lng: 120.477
        },
        {
          zip_code: "920",
          district: "潮州鎮",
          city: "屏東縣",
          lat: 22.5364,
          lng: 120.557
        },
        {
          zip_code: "921",
          district: "泰武鄉",
          city: "屏東縣",
          lat: 22.6041,
          lng: 120.692
        },
        {
          zip_code: "922",
          district: "來義鄉",
          city: "屏東縣",
          lat: 22.5016,
          lng: 120.686
        },
        {
          zip_code: "923",
          district: "萬巒鄉",
          city: "屏東縣",
          lat: 22.5823,
          lng: 120.602
        },
        {
          zip_code: "924",
          district: "崁頂鄉",
          city: "屏東縣",
          lat: 22.5153,
          lng: 120.501
        },
        {
          zip_code: "925",
          district: "新埤鄉",
          city: "屏東縣",
          lat: 22.4868,
          lng: 120.585
        },
        {
          zip_code: "926",
          district: "南州鄉",
          city: "屏東縣",
          lat: 22.4798,
          lng: 120.518
        },
        {
          zip_code: "927",
          district: "林邊鄉",
          city: "屏東縣",
          lat: 22.4414,
          lng: 120.513
        },
        {
          zip_code: "928",
          district: "東港鎮",
          city: "屏東縣",
          lat: 22.4627,
          lng: 120.475
        },
        {
          zip_code: "929",
          district: "琉球鄉",
          city: "屏東縣",
          lat: 22.34,
          lng: 120.371
        },
        {
          zip_code: "931",
          district: "佳冬鄉",
          city: "屏東縣",
          lat: 22.4298,
          lng: 120.548
        },
        {
          zip_code: "932",
          district: "新園鄉",
          city: "屏東縣",
          lat: 22.5172,
          lng: 120.45
        },
        {
          zip_code: "940",
          district: "枋寮鄉",
          city: "屏東縣",
          lat: 22.4033,
          lng: 120.598
        },
        {
          zip_code: "941",
          district: "枋山鄉",
          city: "屏東縣",
          lat: 22.2709,
          lng: 120.657
        },
        {
          zip_code: "942",
          district: "春日鄉",
          city: "屏東縣",
          lat: 22.404,
          lng: 120.698
        },
        {
          zip_code: "943",
          district: "獅子鄉",
          city: "屏東縣",
          lat: 22.2608,
          lng: 120.736
        },
        {
          zip_code: "944",
          district: "車城鄉",
          city: "屏東縣",
          lat: 22.0792,
          lng: 120.743
        },
        {
          zip_code: "945",
          district: "牡丹鄉",
          city: "屏東縣",
          lat: 22.1555,
          lng: 120.817
        },
        {
          zip_code: "946",
          district: "恆春鎮",
          city: "屏東縣",
          lat: 21.9853,
          lng: 120.763
        },
        {
          zip_code: "947",
          district: "滿州鄉",
          city: "屏東縣",
          lat: 22.0493,
          lng: 120.844
        },
        {
          zip_code: "950",
          district: "臺東市",
          city: "臺東縣",
          lat: 22.7517,
          lng: 121.11
        },
        {
          zip_code: "951",
          district: "綠島鄉",
          city: "臺東縣",
          lat: 22.6602,
          lng: 121.49
        },
        {
          zip_code: "952",
          district: "蘭嶼鄉",
          city: "臺東縣",
          lat: 22.0462,
          lng: 121.551
        },
        {
          zip_code: "953",
          district: "延平鄉",
          city: "臺東縣",
          lat: 22.9034,
          lng: 120.983
        },
        {
          zip_code: "954",
          district: "卑南鄉",
          city: "臺東縣",
          lat: 22.7649,
          lng: 121.002
        },
        {
          zip_code: "955",
          district: "鹿野鄉",
          city: "臺東縣",
          lat: 22.9513,
          lng: 121.156
        },
        {
          zip_code: "956",
          district: "關山鎮",
          city: "臺東縣",
          lat: 23.0378,
          lng: 121.177
        },
        {
          zip_code: "957",
          district: "海端鄉",
          city: "臺東縣",
          lat: 23.1148,
          lng: 121.018
        },
        {
          zip_code: "958",
          district: "池上鄉",
          city: "臺東縣",
          lat: 23.0925,
          lng: 121.218
        },
        {
          zip_code: "959",
          district: "東河鄉",
          city: "臺東縣",
          lat: 22.9801,
          lng: 121.252
        },
        {
          zip_code: "961",
          district: "成功鎮",
          city: "臺東縣",
          lat: 23.1266,
          lng: 121.354
        },
        {
          zip_code: "962",
          district: "長濱鄉",
          city: "臺東縣",
          lat: 23.3348,
          lng: 121.426
        },
        {
          zip_code: "963",
          district: "太麻里鄉",
          city: "臺東縣",
          lat: 22.591,
          lng: 120.98
        },
        {
          zip_code: "964",
          district: "金峰鄉",
          city: "臺東縣",
          lat: 22.5816,
          lng: 120.857
        },
        {
          zip_code: "965",
          district: "大武鄉",
          city: "臺東縣",
          lat: 22.3836,
          lng: 120.899
        },
        {
          zip_code: "966",
          district: "達仁鄉",
          city: "臺東縣",
          lat: 22.3843,
          lng: 120.836
        },
        {
          zip_code: "970",
          district: "花蓮市",
          city: "花蓮縣",
          lat: 23.997,
          lng: 121.607
        },
        {
          zip_code: "971",
          district: "新城鄉",
          city: "花蓮縣",
          lat: 24.0558,
          lng: 121.614
        },
        {
          zip_code: "972",
          district: "秀林鄉",
          city: "花蓮縣",
          lat: 24.1237,
          lng: 121.481
        },
        {
          zip_code: "973",
          district: "吉安鄉",
          city: "花蓮縣",
          lat: 23.9555,
          lng: 121.565
        },
        {
          zip_code: "974",
          district: "壽豐鄉",
          city: "花蓮縣",
          lat: 23.8446,
          lng: 121.534
        },
        {
          zip_code: "975",
          district: "鳳林鎮",
          city: "花蓮縣",
          lat: 23.7432,
          lng: 121.47
        },
        {
          zip_code: "976",
          district: "光復鄉",
          city: "花蓮縣",
          lat: 23.6466,
          lng: 121.435
        },
        {
          zip_code: "977",
          district: "豐濱鄉",
          city: "花蓮縣",
          lat: 23.5852,
          lng: 121.494
        },
        {
          zip_code: "978",
          district: "瑞穗鄉",
          city: "花蓮縣",
          lat: 23.5156,
          lng: 121.407
        },
        {
          zip_code: "979",
          district: "萬榮鄉",
          city: "花蓮縣",
          lat: 23.7277,
          lng: 121.319
        },
        {
          zip_code: "981",
          district: "玉里鎮",
          city: "花蓮縣",
          lat: 23.3714,
          lng: 121.36
        },
        {
          zip_code: "982",
          district: "卓溪鄉",
          city: "花蓮縣",
          lat: 23.3906,
          lng: 121.18
        },
        {
          zip_code: "983",
          district: "富里鄉",
          city: "花蓮縣",
          lat: 23.1967,
          lng: 121.298
        }
      ],
      city: "台北市",
      town: "請選擇鄉鎮市區",
      maskData: "",
      openMap: false,
      isLoading: false,
      map: null,
      OSMUrl: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    };
  },
  mounted() {
    const vm = this;
    vm.isLoading = true;
    this.map = this.$utils.map.createMap("map", { maxZoom: 18 });
    // 加載OSM
    this.$utils.map.createTileLayer(this.map, this.OSMUrl, {});
    //設定中心點
    this.map.setView([24.052416, 120.30028], 7);
    //獲取數據
    this.$http
      .get(
        "https://raw.githubusercontent.com/kiang/pharmacies/master/json/points.json"
      )
      .then(res => {
        let data = res.data.features;
        const cluster = vm.setMaskMakers(data);
        vm.map.addLayer(cluster);
        vm.isLoading = false;
      });
  },

  methods: {
    getData() {
      const vm = this;
      this.$http
        .get(
          "https://raw.githubusercontent.com/kiang/pharmacies/master/json/points.json"
        )
        .then(res => {
          vm.maskData = res.data.features;
        });
    },
    addMark(item) {
      window.innerWidth > 500 ? (this.openMap = false) : (this.openMap = true);

      let x = item.geometry.coordinates[0];
      let y = item.geometry.coordinates[1];
      this.map.flyTo([y, x], 18);
    },
    setMaskMakers(data) {
      const cluster = this.$utils.map.createMakerCluster();
      data.forEach(element => {
        let popup = this.$utils.map.createPopup({
          maxWidth: 300,
          minWidth: 200,
          className: "map-popup"
        });
        popup.setContent(
          `<h5>${element.properties.name}</h5>
          <p>電話：${element.properties.phone}</p>
          <div>
            地址：
            <a target="_blank" href="https://www.google.com.tw/maps/place/${
              element.properties.address
            }">${element.properties.address}</a>
          </div>
          <div class="hr"></div>
          <div>
            <div>成人口罩：${element.properties.mask_adult}個</div>
            <div>兒童口罩：${element.properties.mask_child}個</div>
          </div>
          <p>更新時間：${element.properties.updated || "未知"}</p>`
        );
        const marker = this.$utils.map.createMakerByXY(
          element.geometry.coordinates
        );
        //綁popup
        marker.bindPopup(popup);
        cluster.addLayer(marker);
      });
      return cluster;
    }
  },
  computed: {
    myData() {
      const vm = this;
      let arr;

      if (vm.town === "請選擇鄉鎮市區") {
        arr = this.maskData.filter(function(item) {
          let address = item.properties.address;
          return (
            address.indexOf(vm.city) !== -1 &&
            (item.properties.mask_adult !== 0 ||
              item.properties.mask_child !== 0)
          );
        });
      } else {
        let arr2 = this.maskData.filter(function(item) {
          let address = item.properties.address;
          return (
            address.indexOf(vm.city) !== -1 &&
            (item.properties.mask_adult !== 0 ||
              item.properties.mask_child !== 0)
          );
        });

        arr = arr2.filter(item => {
          return item.properties.address.indexOf(vm.town) !== -1;
        });
      }

      return arr;
    },
    townOption() {
      const vm = this;
      let ct = vm.city;
      let arr = vm.areaData.filter(item => {
        return item.city === vm.city;
      });
      return arr;
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss">
@import "./assets/all.scss";
</style>
